export interface IQuotationRejecatable {
  shouldRejectQuotation: boolean;
}

export function instanceOfIQuotationRejecatable(instance: any): instance is IQuotationRejecatable {
  if (!instance) { return false; }
  return (instance.shouldRejectQuotation !== undefined);
}
